// src/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://xbuzwxzxxklktzifbdwr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhidXp3eHp4eGtsa3R6aWZiZHdyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEwOTU0OTgsImV4cCI6MjA4NjY3MTQ5OH0.VlbGxyp93QxylmPneY38i-tlfZC__D3W1dGksD4YLeM';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
